/*global google*/
/*eslint no-undef: "error"*/

import store from "../stores";

const googleAuth = (function() {
  function installClient() {
    const apiUrl = "https://accounts.google.com/gsi/client";
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = apiUrl;
      script.onreadystatechange = script.onload = function() {
        if (!script.readyState || /loaded|complete/.test(script.readyState)) {
          setTimeout(function() {
            resolve();
          }, 500);
        }
      };
      document.getElementsByTagName("head")[0].appendChild(script);
    });
  }
  function handleCredentialResponse(response) {
    store.dispatch("auth/updateAuthInfo", response);
  }
  function initClient(config) {
    return new Promise((resolve, reject) => {
      try {
        google.accounts.id.initialize({
          client_id: config.clientId,
          callback: handleCredentialResponse,
          auto_select: true,
        });

        // trigger signin with google button
        google.accounts.id.renderButton(
          document.getElementById("googleLoginBtn"),
          {
            text: "Login",
            size: "large",
            width: 366, // max width 400
            theme: "outline", // option : filled_black | outline | filled_blue
          }
        );
        google.accounts.id.prompt();
        resolve(true);
      } catch (error) {
        reject("=== initClient error ===", error);
      }
    });
  }

  function Auth() {
    if (!(this instanceof Auth)) return new Auth();
    this.load = async (config) => {
      await installClient();
      await initClient(config);
      this.GoogleAuth = google;
      this.isInit = true;
    };

    this.signOut = () => {
      return new Promise((resolve, reject) => {
        google.accounts.id.revoke(store.state.auth.user.id, (res) => {
          if (res.successful) {
            resolve(true);
          } else {
            reject(res.error);
          }
        });
      });
    };
  }

  return new Auth();
})();

function installGoogleAuthPlugin(Vue, options) {
  //set config
  let GoogleAuthConfig = null;
  let GoogleAuthDefaultConfig = {
    scope: "profile email",
    discoveryDocs: [
      "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest",
    ],
  };
  if (typeof options === "object") {
    GoogleAuthConfig = Object.assign(GoogleAuthDefaultConfig, options);
    if (options.scope) GoogleAuthConfig.scope = options.scope;
    if (!options.clientId) {
      console.warn("clientId is required");
    }
  } else {
    console.warn("invalid option type. Object type accepted only");
  }

  //Install Vue plugin
  Vue.gAuth = googleAuth;
  Object.defineProperties(Vue.prototype, {
    $gAuth: {
      get: function() {
        return Vue.gAuth;
      },
    },
  });
  Vue.gAuth.load(GoogleAuthConfig);
}

export default installGoogleAuthPlugin;
